import IdLessRestService from "./IdLessRestService";


export default class Bank extends IdLessRestService {
    constructor(parentService, parentId) {
        if (parentService) {
            if ( parentId)
                super(`${parentService.baseUrl}/${parentId }/paymentmethod/bank`)
            else
                super(`${parentService.baseUrl}/paymentmethod/bank`)
        }
        else
            throw new Error("Can be only nested service")
    }

}
